
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/blognami-saas/lib/views/_actions/admin/saas_subscribe.js";
                const hash = "EaZdNlTzZM";
                Component.include(createDecoratorsInclude(hash, decorators));
            